if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"html_scss_quick_select_scss-_2f380":1,"html_scss_quick_select_scss-_2f381":1,"html_src_dialogs_animalDetails_ts-html_scss_animal_pedigree_scss":1,"html_src_dialogs_animalPupPedigree_ts":1,"html_scss_animal_cage_details_scss":1,"html_scss_quick_select_scss-_2f382":1,"vendors-html_src_dialogs_cryotankBrowser_ts":1,"html_src_dialogs_cryotankDetails_ts":1,"html_src_dialogs_drugPackageQuickselect_ts":1,"html_src_dialogs_drugRequestDetails_ts":1,"html_src_dialogs_embryoDetails_ts":1,"html_src_dialogs_embryoImport_ts":1,"html_scss_quick_select_scss-_2f383":1,"html_src_dialogs_licenseDetails_scss":1,"html_src_dialogs_licenseSignOff_ts":1,"html_scss_request_status_bar_scss-html_src_dialogs_orderRequestDetails_scss":1,"html_src_dialogs_pupDetails_ts-html_scss_animal_pedigree_scss":1,"html_scss_request_status_bar_scss":1,"html_src_dialogs_spermDetails_ts":1,"html_src_dialogs_spermImport_ts":1,"html_scss_quick_select_scss-_2f384":1,"html_src_dialogs_studQuickselect_ts":1,"html_src_dialogs_tankAnimalImport_scss":1,"html_src_dialogs_tankCrossingDetails_ts-html_src_dialogs_tankAnimalImport_scss":1,"html_scss_popup_details_common_styles_scss-html_src_dialogs_tankAnimalImport_scss-html_src_di-d6a49d":1,"html_scss_quick_select_scss-_2f385":1,"html_src_dialogs_workRequestDetails_scss":1,"html_src_lib_charts_scss":1,"html_src_sites_animalImport_ts":1,"html_src_sites_buildingMap_ts":1,"html_src_sites_colonyPedigree_scss":1,"html_src_sites_pyratStatus_report_ts":1,"html_src_sites_pyratStatus_settings_ts":1,"html_src_sites_pyratStatus_trend_ts":1,"html_src_sites_listView_animalLicenseReport_ts":1,"html_src_sites_listView_apiClientList_ts":1,"html_src_sites_listView_exportReportList_ts":1,"html_src_sites_listView_locationList_ts":1,"html_src_sites_listView_tankLicenseReport_ts":1,"slider":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded